import { Button, Select, Input } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import ImageLoader from '../../../../layout/components/patients/ImageLoader';
import { hasErrorFactory } from '../../../../utils/hasError';

import { IHeading } from '../../../../interfaces/heading';

const { TextArea } = Input;
type Props = {
  onSubmit: (Heading: IHeading) => void;
  onCancel: () => void;
  heading?: IHeading;
  submitText?: string;
};

const defaultSubmitText = 'Add Heading';
const emptyHeading = {
  name: null,
  address: null,
  status: null,
  age: null,
  number: null,
  gender: null,
  img: null
};

const HeadingScheme = Yup.object({
  name: Yup.string().required(),
  // address: Yup.string().required(),
  status: Yup.string().required()
  // age: Yup.string().required(),
  // number: Yup.string().required(),
  // gender: Yup.string().required(),
  // img: Yup.string().required()
});

const SpecieForm = ({
  submitText = defaultSubmitText,
  heading = emptyHeading,
  onSubmit,
  onCancel
}: Props) => {
  const {
    setFieldTouched,
    setFieldValue,
    handleChange,
    handleSubmit,
    setValues,
    handleBlur,
    resetForm,
    touched,
    values,
    errors,
    isValid
  } = useFormik<IHeading>({
    validationSchema: HeadingScheme,
    initialValues: heading,
    onSubmit: (values) => {
      onSubmit(values);
      onCancel();
    }
  });

  const handleGenderSelect = (value) => setFieldValue('gender', value);
  const handleStatusSelect = (value) => setFieldValue('status', value);

  const hasError = hasErrorFactory(touched, errors);

  const handleCancel = () => {
    resetForm();
    onCancel();
  };

  const handleImageLoad = (img) => {
    setValues({ ...values, img });
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        {/* <div className='form-group'>
          <ImageLoader onLoad={handleImageLoad} src={values.img as string} />
        </div> */}

        <div className='form-group'>
          <Input
            placeholder='Name'
            name='name'
            type='text'
            onBlur={handleBlur}
            onChange={handleChange}
            defaultValue={values.name}
            className={hasError('name')}
          />
        </div>

        {/* <div className='row'>
          <div className='col-sm-6 col-12'>
            <div className='form-group'>
              <Select
                placeholder='Gender'
                defaultValue={values.gender}
                onChange={handleGenderSelect}
                className={hasError('gender')}
                onBlur={() => setFieldTouched('gender')}
              >
                <Select.Option value='Male'>Male</Select.Option>
                <Select.Option value='Female'>Female</Select.Option>
              </Select>
            </div>
          </div>
        </div> */}

        <div className='form-group'>
          <Select
            placeholder='Status'
            defaultValue={values.status}
            onChange={handleStatusSelect}
            className={hasError('status')}
            onBlur={() => setFieldTouched('status')}
          >
            <Select.Option value='Active'>Active</Select.Option>
            <Select.Option value='InActive'>InActive</Select.Option>
          </Select>
        </div>

        {/* <div className='form-group'>
          <TextArea
            rows={3}
            name='address'
            placeholder='Description'
            onBlur={handleBlur}
            onChange={handleChange}
            defaultValue={values.address}
            className={hasError('address')}
          />
        </div> */}

        <div className='d-flex justify-content-between buttons-list settings-actions'>
          <Button danger onClick={handleCancel}>
            Cancel
          </Button>

          <Button disabled={!isValid} type='primary' htmlType='submit'>
            {submitText}
          </Button>
        </div>
      </form>
    </>
  );
};

export default SpecieForm;
